import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Camera } from 'lucide-react';

export function CameraInfo({ position }) {
  if (!position) return null;

  const formatNumber = (num) => {
    if (typeof num !== 'number') return '0.00';
    return num.toFixed(2);
  };

  const { position: pos, rotation: rot } = position;

  return (
    <div className="absolute top-4 left-4 z-10">
      <div className="glass rounded-xl p-3 shadow-subtle">
        <div className="flex items-center gap-2 mb-2">
          <Camera className="h-4 w-4 text-primary" />
          <span className="text-xs font-medium text-foreground">Camera Position</span>
        </div>
        
        <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-xs font-mono">
          <div className="text-muted-foreground">
            <span className="text-primary">X:</span> {formatNumber(pos?.x)}
          </div>
          <div className="text-muted-foreground">
            <span className="text-primary">Y:</span> {formatNumber(pos?.y)}
          </div>
          <div className="text-muted-foreground">
            <span className="text-primary">Z:</span> {formatNumber(pos?.z)}
          </div>
          <div className="text-muted-foreground">
            <Badge variant="secondary" className="text-[10px] px-1.5 py-0">
              {position.mode || 'INSIDE'}
            </Badge>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CameraInfo;
